export const PassportRequestPaths = {
  MANAGE_REQUEST_PASSPORT_REQUEST: 'passport-request',
  MANAGE_REQUEST_CREATE_PASSPORT_REQUEST: 'create',
  MANAGE_REQUEST_EDIT_PASSPORT_REQUEST: 'edit/:requestId',
};
